import React, { Component } from 'react';
import menus from '../menus';

class Contact extends Component {
    state = {
        isDisabled: false, // To track the button's disabled state
        timer: 0, // Countdown timer
    };

    handleFormSubmit = async (e) => {
        e.preventDefault(); // Prevent default form behavior

        const name = e.target.name.value;
        const email = e.target.email.value;
        const message = e.target.message.value;

        const formData = { name, email, message };

        this.setState({ isDisabled: true, timer: 15 }); // Disable button and start countdown

        try {
            const response = await fetch('/.netlify/functions/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                window.location.href = "/thank-you.html";
            } else {
                console.error('Error al enviar el formulario:', result.message);
            }
        } catch (error) {
            console.error('Error en la conexión con el servidor:', error);
        } finally {
            // Countdown timer to enable the button again after 15 seconds
            const countdown = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.timer <= 1) {
                        clearInterval(countdown);
                        return { isDisabled: false, timer: 0 }; // Re-enable button
                    }
                    return { timer: prevState.timer - 1 };
                });
            }, 1000);
        }
    };

    render() {
        const { isDisabled, timer } = this.state;

        return (
            <section className="section-padding contact bg-white" id="contact">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Contact with author</h3>
                                <p>An indispensable guide for professionals dedicated to mastering the control of dynamic systems.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-sm-12 col-md-12">
                            <form
                                className="contact__form form-row contact-form"
                                method="post"
                                onSubmit={this.handleFormSubmit}
                            >
                                <div className="row">
                                    <div className="col-12">
                                        <div className="alert alert-success contact__msg" style={{ display: 'none' }} role="alert">
                                            Your message was sent successfully.
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                id="name"
                                                name="name"
                                                className="form-control"
                                                placeholder="Enter Your Name"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="form-control"
                                                placeholder="Enter Your Email Address"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea
                                                id="message"
                                                name="message"
                                                cols="30"
                                                rows="6"
                                                className="form-control"
                                                placeholder="Your Message"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="d-lg-flex justify-content-between mt-4">
                                            <p>* Rest assured. We will not spam at your inbox.</p>
                                            <button
                                                type="submit"
                                                className="btn btn-main-2"
                                                disabled={isDisabled} // Disable button dynamically
                                            >
                                                {isDisabled ? `Thank You!` : "Send Message"} {/* Timer feedback */}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;
